/**
 * Policy status values
 */
export enum PolicyStatusEnum {
	/**
	 * Policy is active
	 */
	ACTIVE = 'active',
	/**
	 * Policy is inactive
	 */
	INACTIVE = 'inactive',
}
